export default __webpack_public_path__ + "assets/static/data/spyne-docs-data.cda4f6d2176c763116551c23c8a32c4d.json";